import useResources from "./use-resources";
import { DOMAIN_TO_ROOT_URL } from "../utils/constants/balances.js";
import moment from "moment/moment";

function getRootUrl(domain, parentId) {
  return parentId
    ? `${DOMAIN_TO_ROOT_URL[domain]}/${parentId}/maintenance-logs`
    : null;
}

function getAlternateRootPath(domain, parentId) {
  return domain && parentId ? getRootUrl(domain, parentId) : undefined;
}

export default function useMaintenanceLogs(domain, parentId) {
  const root_path = getRootUrl(domain, parentId);
  const {
    resources: maintenanceLogs,
    error,
    isLoading,
    create,
    update,
    del,
  } = useResources(root_path);

  function createMaintenanceLog(resource, domain, parentId) {
    return create(resource, {
      sort: (a, b) => moment(b.date_intervention) - moment(a.date_intervention),
      alternateRootPath: getAlternateRootPath(domain, parentId),
    });
  }

  function updateMaintenanceLog(resourceId, resource, domain, parentId) {
    return update(resourceId, resource, {
      sort: (a, b) => moment(b.date_intervention) - moment(a.date_intervention),
      alternateRootPath: getAlternateRootPath(domain, parentId),
    });
  }

  function deleteMaintenanceLog(resourceId, domain, parentId) {
    return del(resourceId, {
      alternateRootPath: getAlternateRootPath(domain, parentId),
    });
  }

  return {
    maintenanceLogs,
    error,
    isLoading,
    createMaintenanceLog,
    updateMaintenanceLog,
    deleteMaintenanceLog,
  };
}
